import { MIN_Y, MAX_HEIGHT } from "../constants.js";
import { ellipseWeight, visit, writeHeight } from "./mask.js";

function clampHeight(height) {
    return Math.max(MIN_Y, Math.min(MAX_HEIGHT, Math.round(height)));
}

export default function applyPlains(heights, resolution, layoutSize, feature, noise) {
    const strength = feature.strength ?? 1;

    visit(feature, resolution, layoutSize, (idx, u, v) => {
        const weight = ellipseWeight(u, v, noise, feature.seed) * strength;
        if (weight <= 0) return;

        const grain = noise.noise2(u * feature.sx * 0.08, v * feature.sz * 0.08) * 0.75;
        const target = feature.height + grain;
        const blended = heights[idx] * (1 - weight) + target * weight;
        writeHeight(heights, idx, clampHeight(blended));
    });
}
